import { SpeedDial, styled, SxProps, Typography, useTheme } from "@mui/material";
import { StyleguideSavioColors } from "../../configuration/themeSettings";

export const TextButtonOperationStyled = styled(Typography, {
    label: "Basket-SpeedDialOperationButton",
})(({ theme: Theme }) => ({
    margin: "10px",
    transition: "visibility 0s, opacity 1s linear",
    visibility: "visible",
    position: "static",
    opacity: 1,
    fontSize: 14,
}));

interface SpeedDialOperationsProps {
    actionleft: number;
    actionbottom: number;
}
export const SpeedDialOperationStyled = styled(SpeedDial, {
    label: "Basket-SpeedDialOperation",
})<SpeedDialOperationsProps>(({ actionleft, actionbottom, theme: Theme }) => ({
    speedDialDesktop: {
        minHeight: "48px",
        bottom: "10px",
        zIndex: 1300,
    },

    speedDialActionsDesktop: {
        position: "fixed",
        left: actionleft + "px",
        bottom: actionbottom + "px",
        zIndex: 1300,
    },

    '.MuiSpeedDial-actions': {

        '> span > span': {
            padding: 0,
        },

        '> .MuiSpeedDialAction-staticTooltip': {
            height: 56,
        },


    },
    "@media print": {
        display: "none",
    }
}));


export const useClasses = (props: any) => {
    const theme = useTheme();

    const classes = {
        speedDialStyle: {
            position: undefined,
            bottom: "80px",
            right: undefined,
            zIndex: !props.open ? 1 : 1300,
            transition: "bottom 0.5s",

            height: "5px",
            alignItems: "flex-end",
            marginRight: "0px",
            color: StyleguideSavioColors.darkBlue,

            "> button": {
                borderRadius: "4px !important",
                marginTop: "10px",
                marginBottom: "10px",
                transition: theme.transitions.create("background-color"),

                "&:hover": {
                    backgroundColor: StyleguideSavioColors.blue,
                },
            },

            '.MuiSpeedDialAction-fab	':{ color: StyleguideSavioColors.mainBlue}
        },
        speedDialTooltipButton: {
            "&:not(.Mui-disabled)": {
                color: "#fff !important",
                backgroundColor: StyleguideSavioColors.mainBlue,
            },
            "&.Mui-disabled": {
                color: "#fff",
                backgroundColor: StyleguideSavioColors.disabledBlue,
            },
        } as SxProps,

        speedDialTooltipButtonWhite: {
            color: StyleguideSavioColors.blue,
            backgroundColor: "#fff",
           

            ".MuiTouchRipple-root": {
                "*": {
                    backgroundColor: StyleguideSavioColors.blue,
                },
            },
            "&.Mui-disabled": {
                color: theme.palette.grey,
                backgroundColor: StyleguideSavioColors.disabledBlue,
            },
            "&.alert": {
                //color: theme.palette.myGray.light,
                //backgroundColor: StyleguideSavioColors.disabledBlue,
            },
            //"&:hover": {
            //    backgroundColor: props.actionOver
            //       ? StyleguideSavioColors.blue
            //        : StyleguideSavioColors.white,
            //    color: props.actionOver
            //        ? StyleguideSavioColors.white
            //        : StyleguideSavioColors.blue,
            //},
        } as SxProps,
        speedDialTooltip: {
            //color: StyleguideSavioColors.blue,
            fontFamily: theme.typography.fontFamily,
            textTransform: "uppercase",

            ".circle": {
                //display: "none",
            },
        } as SxProps,
    };
    return classes;
};
/*



*/